/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './enums';
import '../../connect/v2/common/money';
import '../../fulfillment/behaviors/client/fulfillment_methods_client';
import '../../fulfillment/behaviors/common/geographic';
import '../../fulfillment/behaviors/common/fees';
import '../../fulfillment/behaviors/common/common';
import '../../connect/v2/resources/location';
import '../../omg/fulfillment/fulfillment';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "channelcontrols": {
        "nested": {
          "configuration": {
            "nested": {
              "EntityIdentifier": {
                "fields": {
                  "merchantId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "channelId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "FulfillmentConfiguration": {
                "fields": {
                  "entity": {
                    "type": ".squareup.channelcontrols.configuration.EntityIdentifier",
                    "id": 1,
                    "rule": "optional"
                  },
                  "pickupSettings": {
                    "type": ".squareup.channelcontrols.configuration.PickupSettings",
                    "id": 2,
                    "rule": "optional"
                  },
                  "deliverySettings": {
                    "type": ".squareup.channelcontrols.configuration.DeliverySettings",
                    "id": 3,
                    "rule": "optional"
                  },
                  "genericSettings": {
                    "type": ".squareup.channelcontrols.configuration.GenericSettings",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "PickupSettings": {
                "fields": {
                  "enablementStatus": {
                    "type": ".squareup.channelcontrols.configuration.EnablementStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "prepTimeDuration": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "fulfillmentHoursAvailability": {
                    "type": ".squareup.channelcontrols.configuration.FulfillmentHoursAvailability",
                    "id": 3,
                    "rule": "optional"
                  },
                  "timezone": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "orderSubtotalMinimum": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "isScheduledFulfillmentEnabled": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "enableEtaCalculation": {
                    "type": "bool",
                    "id": 100,
                    "rule": "optional"
                  },
                  "restrictedDates": {
                    "type": ".squareup.channelcontrols.configuration.RestrictedDates",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "instructions": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "enablementScheduledAt": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "maxSchedulingHorizon": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "largeOrderLimitConfig": {
                    "type": ".squareup.channelcontrols.configuration.LargeOrderLimitConfig",
                    "id": 11,
                    "rule": "optional"
                  },
                  "leadTimeSettings": {
                    "type": ".squareup.channelcontrols.configuration.LeadTimeSettings",
                    "id": 12,
                    "rule": "optional"
                  },
                  "fulfillmentMethodId": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "curbsidePickupSettings": {
                    "type": ".squareup.channelcontrols.configuration.CurbsidePickupSettings",
                    "id": 14,
                    "rule": "optional"
                  },
                  "cutoffTime": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  }
                }
              },
              "CurbsidePickupSettings": {
                "fields": {
                  "enabled": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "instructions": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "recipientDetailsConfig": {
                    "type": ".squareup.fulfillment.behaviors.config.RecipientDetailsConfig",
                    "id": 3,
                    "rule": "optional"
                  },
                  "posAlertsEnabled": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "DeliverySettings": {
                "fields": {
                  "enablementStatus": {
                    "type": ".squareup.channelcontrols.configuration.EnablementStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "prepTimeDuration": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "fulfillmentHoursAvailability": {
                    "type": ".squareup.channelcontrols.configuration.FulfillmentHoursAvailability",
                    "id": 3,
                    "rule": "optional"
                  },
                  "timezone": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "orderSubtotalMinimum": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "isScheduledFulfillmentEnabled": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "serviceFeeSettings": {
                    "type": ".squareup.channelcontrols.configuration.ServiceFeeSettings",
                    "id": 7,
                    "rule": "optional"
                  },
                  "restrictedDates": {
                    "type": ".squareup.channelcontrols.configuration.RestrictedDates",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "enablementScheduledAt": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "maxSchedulingHorizon": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "largeOrderLimitConfig": {
                    "type": ".squareup.channelcontrols.configuration.LargeOrderLimitConfig",
                    "id": 11,
                    "rule": "optional"
                  },
                  "leadTimeSettings": {
                    "type": ".squareup.channelcontrols.configuration.LeadTimeSettings",
                    "id": 12,
                    "rule": "optional"
                  },
                  "fulfillmentMethodId": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "sellerPoweredDeliverySettings": {
                    "type": ".squareup.channelcontrols.configuration.DeliverySettings.SellerPoweredDeliverySettings",
                    "id": 14,
                    "rule": "optional"
                  },
                  "onDemandDeliverySettings": {
                    "type": ".squareup.channelcontrols.configuration.DeliverySettings.OnDemandDeliverySettings",
                    "id": 15,
                    "rule": "optional"
                  },
                  "cutoffTime": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "SellerPoweredDeliverySettings": {
                    "fields": {
                      "enabled": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "deliveryAreas": {
                        "type": ".squareup.channelcontrols.configuration.DeliverySettings.SellerPoweredDeliverySettings.DeliveryArea",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "noContactDeliveryEnabled": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      },
                      "provideDeliveryEta": {
                        "type": "bool",
                        "id": 5,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "DeliveryArea": {
                        "fields": {
                          "deliveryArea": {
                            "type": ".squareup.fulfillment.behaviors.common.GeographicArea",
                            "id": 1,
                            "rule": "optional"
                          },
                          "fees": {
                            "type": ".squareup.fulfillment.behaviors.common.Fee",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "enabled": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional"
                          },
                          "deliveryTravelTimeEstimate": {
                            "type": ".squareup.fulfillment.behaviors.common.TimeRange",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "OnDemandDeliverySettings": {
                    "fields": {
                      "enabled": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "fees": {
                        "type": ".squareup.fulfillment.behaviors.common.Fee",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "courierProviders": {
                        "type": ".squareup.channelcontrols.configuration.DeliverySettings.OnDemandDeliverySettings.CourierProvider",
                        "id": 3,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "CourierProvider": {
                        "values": {
                          "COURIER_PROVIDER_UNSPECIFIED": 0,
                          "COURIER_PROVIDER_NASH": 1,
                          "COURIER_PROVIDER_DOORDASH": 2
                        }
                      }
                    }
                  }
                }
              },
              "LeadTimeSettings": {
                "fields": {
                  "enabled": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "advanceDurationNotice": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cutoffTime": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "LargeOrderLimitConfig": {
                "fields": {
                  "maxQuantity": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "maxSubtotalAmountMoney": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "activeLimitMode": {
                    "type": ".squareup.channelcontrols.configuration.LargeOrderLimitMode",
                    "id": 3,
                    "rule": "optional"
                  },
                  "message": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "GenericSettings": {
                "fields": {
                  "orderThrottling": {
                    "type": ".squareup.channelcontrols.configuration.OrderThrottling",
                    "id": 1,
                    "rule": "optional"
                  },
                  "timezone": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "OrderThrottling": {
                "fields": {
                  "enablementStatus": {
                    "type": ".squareup.channelcontrols.configuration.EnablementStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "maxOrderCountPerWindow": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FulfillmentHoursAvailability": {
                "fields": {
                  "hours": {
                    "type": ".squareup.connect.v2.resources.BusinessHoursPeriod",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "useBusinessLocationHours": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ServiceFeeSettings": {
                "fields": {
                  "type": {
                    "type": ".squareup.channelcontrols.configuration.ServiceFeeType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amountMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "percentage": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "Target": {
                "fields": {
                  "type": {
                    "type": ".squareup.channelcontrols.configuration.TargetType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "id": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "PauseTargetConfig": {
                "fields": {
                  "target": {
                    "type": ".squareup.channelcontrols.configuration.Target",
                    "id": 1,
                    "rule": "optional"
                  },
                  "pauseEndTime": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "pauseConfig": {
                    "type": ".squareup.channelcontrols.configuration.PauseConfig",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "PauseConfig": {
                "fields": {
                  "pauseEndTime": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "fulfillmentType": {
                    "type": ".squareup.omg.fulfillment.FulfillmentType",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "TargetOperationResult": {
                "fields": {
                  "target": {
                    "type": ".squareup.channelcontrols.configuration.Target",
                    "id": 1,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.channelcontrols.configuration.PauseStatus",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "ResumeTargetConfig": {
                "fields": {
                  "target": {
                    "type": ".squareup.channelcontrols.configuration.Target",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "TargetPauseStatus": {
                "fields": {
                  "target": {
                    "type": ".squareup.channelcontrols.configuration.Target",
                    "id": 1,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.channelcontrols.configuration.PauseStatus",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "PauseStatus": {
                "fields": {
                  "isPaused": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "currentPause": {
                    "type": ".squareup.channelcontrols.configuration.PauseInfo",
                    "id": 2,
                    "rule": "optional"
                  },
                  "fulfillmentType": {
                    "type": ".squareup.omg.fulfillment.FulfillmentType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "endOfDayUtc": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "PauseInfo": {
                "fields": {
                  "status": {
                    "type": ".squareup.channelcontrols.configuration.PauseStatusType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "startTime": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "endTime": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "source": {
                    "type": ".squareup.channelcontrols.configuration.PauseSource",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "ConfigurationResult": {
                "fields": {
                  "entity": {
                    "type": ".squareup.channelcontrols.configuration.EntityIdentifier",
                    "id": 1,
                    "rule": "optional"
                  },
                  "configuration": {
                    "type": ".squareup.channelcontrols.configuration.FulfillmentConfiguration",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "AvailabilityWindow": {
                "fields": {
                  "startAt": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "endAt": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "availabilityCutoffAt": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "PreOrderingConfiguration": {
                "fields": {
                  "enabled": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "availabilityWindows": {
                    "type": ".squareup.channelcontrols.configuration.AvailabilityWindow",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "PrepTimeConfiguration": {
                "fields": {
                  "duration": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cutoff": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FulfillmentTypePreferences": {
                "fields": {
                  "enablement": {
                    "type": ".squareup.channelcontrols.configuration.EnablementStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "preordering": {
                    "type": ".squareup.channelcontrols.configuration.PreOrderingConfiguration",
                    "id": 2,
                    "rule": "optional"
                  },
                  "prepTime": {
                    "type": ".squareup.channelcontrols.configuration.PrepTimeConfiguration",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ItemPreferences": {
                "fields": {
                  "pickup": {
                    "type": ".squareup.channelcontrols.configuration.FulfillmentTypePreferences",
                    "id": 1,
                    "rule": "optional"
                  },
                  "delivery": {
                    "type": ".squareup.channelcontrols.configuration.FulfillmentTypePreferences",
                    "id": 2,
                    "rule": "optional"
                  },
                  "dineIn": {
                    "type": ".squareup.channelcontrols.configuration.FulfillmentTypePreferences",
                    "id": 3,
                    "rule": "optional"
                  },
                  "shipping": {
                    "type": ".squareup.channelcontrols.configuration.FulfillmentTypePreferences",
                    "id": 4,
                    "rule": "optional"
                  },
                  "digital": {
                    "type": ".squareup.channelcontrols.configuration.FulfillmentTypePreferences",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "RestrictedDates": {
                "fields": {
                  "startDate": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "endDate": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "recurrence": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.EntityIdentifier && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.FulfillmentConfiguration && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.PickupSettings && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.CurbsidePickupSettings && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.DeliverySettings && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.DeliverySettings?.nested?.SellerPoweredDeliverySettings && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.DeliverySettings?.nested?.SellerPoweredDeliverySettings?.nested?.DeliveryArea && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.DeliverySettings?.nested?.OnDemandDeliverySettings && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.DeliverySettings?.nested?.OnDemandDeliverySettings?.nested?.CourierProvider && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.LeadTimeSettings && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.LargeOrderLimitConfig && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.GenericSettings && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.OrderThrottling && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.FulfillmentHoursAvailability && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.ServiceFeeSettings && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.Target && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.PauseTargetConfig && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.PauseConfig && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.TargetOperationResult && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.ResumeTargetConfig && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.TargetPauseStatus && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.PauseStatus && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.PauseInfo && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.ConfigurationResult && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.AvailabilityWindow && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.PreOrderingConfiguration && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.PrepTimeConfiguration && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.FulfillmentTypePreferences && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.ItemPreferences && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.RestrictedDates) {
  $root.addJSON(jsonData);
}

/**
 * EntityIdentifier represents a unique identifier for an entity in the fulfillment preferences hierarchy
 *
 * SOURCE EntityIdentifier @ squareup/channelcontrols/configuration/models.proto at 20:1
 */
export const EntityIdentifier = $root.lookupType('squareup.channelcontrols.configuration.EntityIdentifier');
fixType(EntityIdentifier);
Builder.createAndAttachToType(EntityIdentifier);
/**
 * SOURCE FulfillmentConfiguration @ squareup/channelcontrols/configuration/models.proto at 37:1
 */
export const FulfillmentConfiguration = $root.lookupType('squareup.channelcontrols.configuration.FulfillmentConfiguration');
fixType(FulfillmentConfiguration);
Builder.createAndAttachToType(FulfillmentConfiguration);
/**
 * SOURCE PickupSettings @ squareup/channelcontrols/configuration/models.proto at 44:1
 */
export const PickupSettings = $root.lookupType('squareup.channelcontrols.configuration.PickupSettings');
fixType(PickupSettings);
Builder.createAndAttachToType(PickupSettings);
/**
 * @desc Configuration for curbside pickup as an enhancement to standard pickup.
 *
 * SOURCE CurbsidePickupSettings @ squareup/channelcontrols/configuration/models.proto at 132:1
 */
export const CurbsidePickupSettings = $root.lookupType('squareup.channelcontrols.configuration.CurbsidePickupSettings');
fixType(CurbsidePickupSettings);
Builder.createAndAttachToType(CurbsidePickupSettings);
/**
 * SOURCE DeliverySettings @ squareup/channelcontrols/configuration/models.proto at 154:1
 */
export const DeliverySettings = $root.lookupType('squareup.channelcontrols.configuration.DeliverySettings');
fixType(DeliverySettings);
Builder.createAndAttachToType(DeliverySettings);
/**
 * SOURCE SellerPoweredDeliverySettings @ squareup/channelcontrols/configuration/models.proto at 238:3
 */
DeliverySettings.SellerPoweredDeliverySettings = $root.lookupType('squareup.channelcontrols.configuration.DeliverySettings.SellerPoweredDeliverySettings');
fixType(DeliverySettings.SellerPoweredDeliverySettings);
Builder.createAndAttachToType(DeliverySettings.SellerPoweredDeliverySettings);
/**
 * SOURCE DeliveryArea @ squareup/channelcontrols/configuration/models.proto at 259:5
 */
DeliverySettings.SellerPoweredDeliverySettings.DeliveryArea = $root.lookupType('squareup.channelcontrols.configuration.DeliverySettings.SellerPoweredDeliverySettings.DeliveryArea');
fixType(DeliverySettings.SellerPoweredDeliverySettings.DeliveryArea);
Builder.createAndAttachToType(DeliverySettings.SellerPoweredDeliverySettings.DeliveryArea);
/**
 * SOURCE OnDemandDeliverySettings @ squareup/channelcontrols/configuration/models.proto at 282:3
 */
DeliverySettings.OnDemandDeliverySettings = $root.lookupType('squareup.channelcontrols.configuration.DeliverySettings.OnDemandDeliverySettings');
fixType(DeliverySettings.OnDemandDeliverySettings);
Builder.createAndAttachToType(DeliverySettings.OnDemandDeliverySettings);
/**
 * SOURCE CourierProvider @ squareup/channelcontrols/configuration/models.proto at 298:5
 */
DeliverySettings.OnDemandDeliverySettings.CourierProvider = $root.lookupEnum('squareup.channelcontrols.configuration.DeliverySettings.OnDemandDeliverySettings.CourierProvider').values;
/**
 * SOURCE LeadTimeSettings @ squareup/channelcontrols/configuration/models.proto at 307:1
 */
export const LeadTimeSettings = $root.lookupType('squareup.channelcontrols.configuration.LeadTimeSettings');
fixType(LeadTimeSettings);
Builder.createAndAttachToType(LeadTimeSettings);
/**
 * @desc Configuration for large order limits that restrict orders exceeding quantity or subtotal thresholds.
 *
 * SOURCE LargeOrderLimitConfig @ squareup/channelcontrols/configuration/models.proto at 329:1
 */
export const LargeOrderLimitConfig = $root.lookupType('squareup.channelcontrols.configuration.LargeOrderLimitConfig');
fixType(LargeOrderLimitConfig);
Builder.createAndAttachToType(LargeOrderLimitConfig);
/**
 * SOURCE GenericSettings @ squareup/channelcontrols/configuration/models.proto at 351:1
 */
export const GenericSettings = $root.lookupType('squareup.channelcontrols.configuration.GenericSettings');
fixType(GenericSettings);
Builder.createAndAttachToType(GenericSettings);
/**
 * SOURCE OrderThrottling @ squareup/channelcontrols/configuration/models.proto at 363:1
 */
export const OrderThrottling = $root.lookupType('squareup.channelcontrols.configuration.OrderThrottling');
fixType(OrderThrottling);
Builder.createAndAttachToType(OrderThrottling);
/**
 * SOURCE FulfillmentHoursAvailability @ squareup/channelcontrols/configuration/models.proto at 374:1
 */
export const FulfillmentHoursAvailability = $root.lookupType('squareup.channelcontrols.configuration.FulfillmentHoursAvailability');
fixType(FulfillmentHoursAvailability);
Builder.createAndAttachToType(FulfillmentHoursAvailability);
/**
 * --
 * @desc Details of the service fee including the type of fee, money or percentage amount
 *
 * SOURCE ServiceFeeSettings @ squareup/channelcontrols/configuration/models.proto at 385:1
 */
export const ServiceFeeSettings = $root.lookupType('squareup.channelcontrols.configuration.ServiceFeeSettings');
fixType(ServiceFeeSettings);
Builder.createAndAttachToType(ServiceFeeSettings);
/**
 * @desc Identifies a sales channel or scope targeted by a pause action.
 *
 * SOURCE Target @ squareup/channelcontrols/configuration/models.proto at 394:1
 */
export const Target = $root.lookupType('squareup.channelcontrols.configuration.Target');
fixType(Target);
Builder.createAndAttachToType(Target);
/**
 * SOURCE PauseTargetConfig @ squareup/channelcontrols/configuration/models.proto at 403:1
 */
export const PauseTargetConfig = $root.lookupType('squareup.channelcontrols.configuration.PauseTargetConfig');
fixType(PauseTargetConfig);
Builder.createAndAttachToType(PauseTargetConfig);
/**
 * SOURCE PauseConfig @ squareup/channelcontrols/configuration/models.proto at 417:1
 */
export const PauseConfig = $root.lookupType('squareup.channelcontrols.configuration.PauseConfig');
fixType(PauseConfig);
Builder.createAndAttachToType(PauseConfig);
/**
 * SOURCE TargetOperationResult @ squareup/channelcontrols/configuration/models.proto at 429:1
 */
export const TargetOperationResult = $root.lookupType('squareup.channelcontrols.configuration.TargetOperationResult');
fixType(TargetOperationResult);
Builder.createAndAttachToType(TargetOperationResult);
/**
 * SOURCE ResumeTargetConfig @ squareup/channelcontrols/configuration/models.proto at 440:1
 */
export const ResumeTargetConfig = $root.lookupType('squareup.channelcontrols.configuration.ResumeTargetConfig');
fixType(ResumeTargetConfig);
Builder.createAndAttachToType(ResumeTargetConfig);
/**
 * SOURCE TargetPauseStatus @ squareup/channelcontrols/configuration/models.proto at 444:1
 */
export const TargetPauseStatus = $root.lookupType('squareup.channelcontrols.configuration.TargetPauseStatus');
fixType(TargetPauseStatus);
Builder.createAndAttachToType(TargetPauseStatus);
/**
 * SOURCE PauseStatus @ squareup/channelcontrols/configuration/models.proto at 453:1
 */
export const PauseStatus = $root.lookupType('squareup.channelcontrols.configuration.PauseStatus');
fixType(PauseStatus);
Builder.createAndAttachToType(PauseStatus);
/**
 * SOURCE PauseInfo @ squareup/channelcontrols/configuration/models.proto at 471:1
 */
export const PauseInfo = $root.lookupType('squareup.channelcontrols.configuration.PauseInfo');
fixType(PauseInfo);
Builder.createAndAttachToType(PauseInfo);
/**
 * @desc Result of a single configuration operation in a bulk request.
 *
 * SOURCE ConfigurationResult @ squareup/channelcontrols/configuration/models.proto at 496:1
 */
export const ConfigurationResult = $root.lookupType('squareup.channelcontrols.configuration.ConfigurationResult');
fixType(ConfigurationResult);
Builder.createAndAttachToType(ConfigurationResult);
/**
 * SOURCE AvailabilityWindow @ squareup/channelcontrols/configuration/models.proto at 513:1
 */
export const AvailabilityWindow = $root.lookupType('squareup.channelcontrols.configuration.AvailabilityWindow');
fixType(AvailabilityWindow);
Builder.createAndAttachToType(AvailabilityWindow);
/**
 * SOURCE PreOrderingConfiguration @ squareup/channelcontrols/configuration/models.proto at 530:1
 */
export const PreOrderingConfiguration = $root.lookupType('squareup.channelcontrols.configuration.PreOrderingConfiguration');
fixType(PreOrderingConfiguration);
Builder.createAndAttachToType(PreOrderingConfiguration);
/**
 * SOURCE PrepTimeConfiguration @ squareup/channelcontrols/configuration/models.proto at 542:1
 */
export const PrepTimeConfiguration = $root.lookupType('squareup.channelcontrols.configuration.PrepTimeConfiguration');
fixType(PrepTimeConfiguration);
Builder.createAndAttachToType(PrepTimeConfiguration);
/**
 * SOURCE FulfillmentTypePreferences @ squareup/channelcontrols/configuration/models.proto at 554:1
 */
export const FulfillmentTypePreferences = $root.lookupType('squareup.channelcontrols.configuration.FulfillmentTypePreferences');
fixType(FulfillmentTypePreferences);
Builder.createAndAttachToType(FulfillmentTypePreferences);
/**
 * SOURCE ItemPreferences @ squareup/channelcontrols/configuration/models.proto at 571:1
 */
export const ItemPreferences = $root.lookupType('squareup.channelcontrols.configuration.ItemPreferences');
fixType(ItemPreferences);
Builder.createAndAttachToType(ItemPreferences);
/**
 * --
 * @desc Represents a date range with special handling requirements, such as holidays or special events.
 * The date range can be a single day (start_date equals end_date) or span multiple days.
 * The range can have a recurrence pattern.
 *
 * SOURCE RestrictedDates @ squareup/channelcontrols/configuration/models.proto at 603:1
 */
export const RestrictedDates = $root.lookupType('squareup.channelcontrols.configuration.RestrictedDates');
fixType(RestrictedDates);
Builder.createAndAttachToType(RestrictedDates);